module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/about/eco-concious/ECOCONS_04_ecofriendlyfood.png";